<template>
  <div>
    <van-nav-bar
      :fixed="fixed"
      :placeholder="placeholder"
      :border="border"
      :style="'background:#574AA5'"
      :title="title"
      left-arrow
      @click-left="onClickLeft"
    />
  </div>
</template>

<script>
import Vue from "vue";
import { NavBar } from "vant";

Vue.use(NavBar);
export default {
  props: {
    title: {
      type: String,
      default() {
        return "";
      }
    },
    toback: {
      type: String,
      default() {
        return "";
      }
    },
    bg: {
      type: String,
      default() {
        return "linear-gradient(to right, #52BDFF 0%, #0084FF 100%)";
      }
    },
    fixed: {
      type: Boolean,
      default() {
        return false;
      }
    },
    placeholder: {
      type: Boolean,
      default() {
        return false;
      }
    },
    border: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    onClickLeft: function() {
      if (this.toback) {
        this.$router.replace({ path: this.toback });
      } else {
        this.$router.back(-1);
      }
    },
    onClickRight: function() {}
  }
};
</script>

<style scoped>
	/deep/.van-nav-bar .van-icon {
	    color: #fff;
	}
	/deep/.van-nav-bar__title {
		color: #fff; 
	}
</style>
